export default __webpack_public_path__ + "static/media/electricCycle.6238cd63.svg";